module.exports = __webpack_public_path__ + "media/ambience_beweegbuddy_1.f0bbb457.mp3";